export const STORAGE_KEYS = {
  MULTIPLE_TEAMS_TOAST_SHOWN: 'fly:multiple_teams_toast_shown',
} as const;
